import * as Yup from 'yup'

export const schema = Yup.object({
  method: Yup.number().notRequired(),
})
